import React, { FC, useRef, useState } from 'react';
import CheckBox from 'src/components/atoms/CheckBox';
import { familyInitDataStore } from 'src/store/familyInfo';
import '../style.scss';

interface Props {}
const FamilyDescription: FC<Props> = () => {
  const checkTypeEvt = () => {};
  const familyInitResult = familyInitDataStore((state: any) => state.result);
  const familyInitBind = familyInitDataStore((state: any) => state.bind);
  const checkClickEvt = (e: any, status: string, field?: string) => {
    if (field) {
      const vType = status === 'on' ? false : true;
      familyInitResult[field] = vType;
      familyInitBind(familyInitResult);
    }
  };

  return (
    <div className="_creditcard_add_info_description">
      <div className="_grid">
        <div className="_label">
          <div className="_row">
            <div className="_col _col_dor_a _ht_60">
              <div className="_tit">공제대상자</div>
            </div>
            <div className="_col _col_dor_b _ht_60">
              <div className="_row">
                <div className="_col _col_dor_b _ht_30">
                  <div className="_tit">기부금유형</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_dor_b_a _ht_30">
                  <div className="_tit">번호</div>
                </div>
                <div className="_col _col_dor_b_b _ht_30">
                  <div className="_tit">유형</div>
                </div>
                <div className="_col _col_dor_b_a _ht_30">
                  <div className="_tit">코드</div>
                </div>
              </div>
            </div>
            <div className="_col _col_dor_c _ht_60">
              <div className="_tit">공제한도</div>
            </div>
            <div className="_col _col_dor_d _ht_60">
              <div className="_tit">
                이용공제
                <br />
                가능기간
              </div>
            </div>
          </div>
        </div>

        <div className="_content">
          <div className="_row">
            <div className="_col _col_dor_a">
              <div className="_cont _left">
                <div className="item">① 근로자 본인 </div>
                <div className="item">② 기본공제대상 배우자 </div>
                <div className="item">
                  ③ 기본공제대상 부양가족(나이의 제한을 받지 않으며, 다른 거주자의 기본공제를
                  적용받은 사람은 제외)
                </div>
              </div>
            </div>
            <div className="_col _col_dor_a_ex">
              <div className="_row">
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">㉠</div>
                </div>
                <div className="_col _col_dor_b_b _bor_l">
                  <div className="_cont _left">정치자금기부금</div>
                </div>
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">20</div>
                </div>
                <div className="_col _col_dor_c_b _bor_l">
                  <div className="_cont _left">근로소득금액</div>
                </div>
                <div className="_col _col_dor_d _bor_l">
                  <div className="_cont _left">-</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">㉡</div>
                </div>
                <div className="_col _col_dor_b_b _bor_l">
                  <div className="_cont _left">고향사랑기부금</div>
                </div>
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">43</div>
                </div>
                <div className="_col _col_dor_c_b _bor_l">
                  <div className="_cont _left"> 근로소득금액-㉠의 공제액</div>
                </div>
                <div className="_col _col_dor_d _bor_l">
                  <div className="_cont _left">-</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">㉢</div>
                </div>
                <div className="_col _col_dor_b_b _bor_l">
                  <div className="_cont _left">특례기부금</div>
                </div>
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">10</div>
                </div>
                <div className="_col _col_dor_c_b _bor_l">
                  <div className="_cont _left">근로소득금액 - ㉠의 공제액 - ㉡의 공제액</div>
                </div>
                <div className="_col _col_dor_d _bor_l">
                  <div className="_cont _left">10년</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">㉣</div>
                </div>
                <div className="_col _col_dor_b_b _bor_l">
                  <div className="_cont _left">우리사주조합기부금</div>
                </div>
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_cont _mid">42</div>
                </div>
                <div className="_col _col_dor_c_b _bor_l">
                  <div className="_cont _left">
                    (근로소득금액-㉠의 공제액-㉡의 공제액-㉢의 공제액)x30%
                  </div>
                </div>
                <div className="_col _col_dor_d _bor_l">
                  <div className="_cont _left">-</div>
                </div>
              </div>
              <div className="_row">
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_row">
                    <div className="_col _col_dor_b_a">
                      <div className="_cont _mid">㉤</div>
                    </div>
                  </div>
                  <div className="_row">
                    <div className="_col _col_dor_b_a">
                      <div className="_cont _mid">㉥</div>
                    </div>
                  </div>
                </div>
                <div className="_col _col_dor_b_b _bor_l">
                  <div className="_row">
                    <div className="_col">
                      <div className="_cont _mid">일반기부금(종교단체 외)</div>
                    </div>
                  </div>
                  <div className="_row">
                    <div className="_col">
                      <div className="_cont _mid">일반기부금(종교단체)</div>
                    </div>
                  </div>
                </div>
                <div className="_col _col_dor_b_a _bor_l">
                  <div className="_row">
                    <div className="_col _col_dor_b_a">
                      <div className="_cont _mid">40</div>
                    </div>
                  </div>
                  <div className="_row">
                    <div className="_col _col_dor_b_a">
                      <div className="_cont _mid">41</div>
                    </div>
                  </div>
                </div>
                <div className="_col _col_dor_c_b _bor_l">
                  <div className="_cont _left">
                    <div className="item">
                      종교단체 일반기부금이 있는 경우(이월액만 있는 경우 포함)
                    </div>
                    <div className="item">
                      (근로소득금액-㉠의 공제액-㉡의 공제액-㉢의 공제액-㉣의 공제액) x10% +
                      Min[(근로소득금액-㉠의 공제액-㉡의 공제액 -㉢의 공제액-㉣의 공제액)x20%,
                      종교단체외 일반기부금]
                    </div>
                    <div className="item">
                      ·종교단체 일반기부금이 없는 경우 (근로소득금액-㉠의 공제액-㉡의 공제액-㉢의
                      공제액-㉣의 공제액)x30%
                    </div>
                  </div>
                </div>
                <div className="_col _col_dor_d _bor_l">
                  <div className="_cont _left">10년</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FamilyDescription;
